import { render } from "./InputPassword.vue?vue&type=template&id=5b71c9b0"
import script from "./InputPassword.vue?vue&type=script&lang=js"
export * from "./InputPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__